import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { Button, Grid } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";

import { showToast } from "utils/toast";
import usePatientModal from "components/pages/transmissions/modal/patient/usePatientModal";
import PatientBasicInfo from "components/pages/transmissions/modal/patient/tabs/generalInformation/profile/PatientBasicInfo";

import {
  setFetchPatientReports,
  updateNextBillingDateChangedStatus,
} from "app/store/transmission/slice/transmissionSlice";
import { transmissionTableApi } from "app/store/transmission/api/transmissionTableApi";
import { liveCallTasksApi } from "app/store/liveCallTasks/api/liveCallTasksApi";

const PatientProfileForm = () => {
  const { handleProfile, handleCancel, patientSerialNumber, patientId } =
    usePatientModal();

  const [isEditMode, setIsEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleSave = async (values) => {
    try {
      setIsLoading(true);
      const response = await handleProfile(values);
      if (response) {
        setIsEditMode(false);
        dispatch(updateNextBillingDateChangedStatus(false));
        dispatch(
          transmissionTableApi.util.invalidateTags([
            "getAlertBanner",
            patientSerialNumber,
            "patientProfile",
            patientId,
          ])
        );

        if (!values?.active && values?.deactivate_reason) {
          dispatch(liveCallTasksApi.util.invalidateTags(["liveCallTasks"]));
        }
      }
    } catch (error) {
      showToast({ message: error?.message, type: "error" });
    } finally {
      setIsLoading(false);
      dispatch(setFetchPatientReports(false));
    }
  };

  return (
    <>
      <Grid container className="patient-modal__aside-container mb-3">
        <Grid item xs={9} className="d-flex align-items-center">
          <Grid item xs={2}>
            <div className="patient-form__info--header mt-0">
              Basic Information
            </div>
          </Grid>
        </Grid>
        {!isEditMode && (
          <Grid item xs={3} className="text-right">
            <Button
              variant="text"
              color="secondary"
              className="profile-edit-button"
              onClick={() => setIsEditMode(true)}
            >
              <EditIcon
                className="patient-edit-icon billing-cycle-edit-icon"
                data-action="edit-basic-information-icon"
              />
              Edit
            </Button>
          </Grid>
        )}

        <PatientBasicInfo
          style={{ marginBottom: "16px" }}
          isLoading={isLoading}
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
          handleCancel={handleCancel}
          handleSave={handleSave}
        />
      </Grid>
    </>
  );
};

export default PatientProfileForm;
